import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9db6c8e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-dashboard-root-notifications" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box__headline" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Obavijesti ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "box__list"
}
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "message" }
const _hoisted_8 = { class: "date-and-action" }
const _hoisted_9 = { class: "date" }
const _hoisted_10 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.notifications.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: notification.id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, " #" + _toDisplayString(key + 1) + " - " + _toDisplayString(notification.user.content.name) + " " + _toDisplayString(notification.user.content.surname), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(notification.content.message), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("strong", null, " Datum: " + _toDisplayString(_ctx.moment(notification.created_at).format('DD.MM.YYYY.')), 1)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, " Nema podataka... "))
    ])
  ]))
}